export default __webpack_public_path__ + "static/media/openshift.8a995c62.svg";